import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "billing-details" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "plan-payment" }
const _hoisted_5 = {
  key: 1,
  class: "billing-cancel"
}
const _hoisted_6 = { class: "billing-cancel__text" }
const _hoisted_7 = { class: "billing-cancel__link" }
const _hoisted_8 = {
  key: 2,
  class: "billing-cancel"
}

import { ref } from 'vue'

import { useWait } from '@/app/composables/useWait'
import type { BillingView } from '@/models/billing'

import BillingCoupon from './BillingCoupon.vue'

import PlanInfoMonthly from './BillingDataPaid.PlanInfo.Monthly.vue'
import PlanInfoAnnual from './BillingDataPaid.PlanInfo.Annual.vue'
import PaymentInfo from './BillingDataPaid.PaymentInfo.vue'
import CancelFlowPopup from './CancelFlowPopup.vue'
import InfoQuestions from './InfoQuestions.vue'

import BillingNotifications from './BillingNotifications.vue'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingDataPaid',
  props: {
    billing: {}
  },
  emits: ['subscribed'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const wait = useWait()
const emit = __emit

const cancelFlow = ref<InstanceType<typeof CancelFlowPopup> | null>(null)

function cancelClick(): void {
  Mixpanel.trackCancelSubscriptionClick(props.billing)
  cancelFlow.value?.show()
}

async function reactivate(): Promise<void> {
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.plan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (error) {
    wait.end('Subscribing')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.billing.showDiscountBanner)
          ? (_openBlock(), _createBlock(BillingCoupon, {
              key: 0,
              billing: __props.billing,
              class: "billing-notifications__prompt"
            }, null, 8, ["billing"]))
          : _createCommentVNode("", true),
        _createVNode(BillingNotifications, { billing: __props.billing }, null, 8, ["billing"]),
        _createElementVNode("div", _hoisted_4, [
          (__props.billing.plan.id === 'plan_monthly')
            ? (_openBlock(), _createBlock(PlanInfoMonthly, {
                key: 0,
                billing: __props.billing
              }, null, 8, ["billing"]))
            : _createCommentVNode("", true),
          (__props.billing.plan.id === 'plan_annual')
            ? (_openBlock(), _createBlock(PlanInfoAnnual, {
                key: 1,
                billing: __props.billing
              }, null, 8, ["billing"]))
            : _createCommentVNode("", true),
          _createVNode(PaymentInfo, { billing: __props.billing }, null, 8, ["billing"])
        ]),
        (__props.billing.cancel_at_period_end)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _cache[3] || (_cache[3] = _createTextVNode(" Want to reactivate your Shortform subscription? ", -1)),
                _createVNode(_component_v_wait, {
                  class: "billing-cancel__wait",
                  for: "Subscribing"
                }, {
                  waiting: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, [
                      _cache[0] || (_cache[0] = _createTextVNode(" Processing... ", -1)),
                      _createVNode(_component_button_spinner)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "billing-cancel__link",
                      href: "javascript:void(0);",
                      onClick: reactivate
                    }, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("span", null, " Click here to resubscribe ", -1)
                    ]))]),
                    _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", { class: "billing-cancel__text" }, [
                _cache[4] || (_cache[4] = _createTextVNode(" Want to stop your Shortform subscription? ", -1)),
                _createElementVNode("a", {
                  class: "billing-cancel__link",
                  href: "javascript:void(0);",
                  onClick: cancelClick
                }, "Click here to cancel"),
                _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
              ]),
              _createVNode(CancelFlowPopup, {
                ref_key: "cancelFlow",
                ref: cancelFlow,
                billing: __props.billing
              }, null, 8, ["billing"])
            ]))
      ])
    ]),
    _createVNode(InfoQuestions)
  ]))
}
}

})